<template>
  <div class='login-simplified'>
    <div class="header active">
      <div class="zhl-flex-c">
        <img class="icon-logo"
             src="@/assets/images/login/icon-logo-1.png">
      </div>
      <div class="zhl-flex-c">云教英语听说专练系统</div>
    </div>
    <div class="btn zhl-flex-c active"
         @click="handleBtn(6)">登录</div>
  </div>
</template>

<script>
export default {
  name: 'LoginSimplified',
  data() {
    return {

    }
  },
  methods: {
    handleBtn() {
      // 云南教育云登录
      location.replace('https://djysso.yneducloud.com/login?CLIENTIDENT=djy-yingyutingshuo&REDIRECTURI=https://yjts.yneducloud.com/EnglishHome.html')
    }
  }
}
</script>

<style lang='less' scoped>
.login-simplified {
  .header {
    padding: 44px 0 50px 0;
    font-size: 22px;
    font-weight: bold;
    color: #333333;

    &.active {
      padding: 150px 0 80px 0;
    }

    .icon-logo {
      margin-bottom: 15px;
      display: block;
      width: 66px;
      //height: 60px;
    }
  }
  .btn {
    margin: 20px 40px 14px 40px;
    width: 295px;
    height: 48px;
    background: rgba(70, 213, 132, 0.5);
    border-radius: 24px;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 2px;
    cursor: pointer;

    &.active {
      background: rgba(70, 213, 132, 1);
    }
  }
}
</style>
